import { ForumApiError } from 'components/Forum/forumTopicsCache';

export const ARK_SESSION_EXPIRED_CODE = 'ARK_SESSION_EXPIRED';

export function isArkSessionExpiredError(error: unknown): error is ForumApiError {
  return error instanceof ForumApiError && error.code === ARK_SESSION_EXPIRED_CODE;
}

export function getCurrentRelativeUrl(): string {
  return `${window.location.pathname}${window.location.search}${window.location.hash}`;
}

export function getForumSessionRecoveryLoginUrl(next = getCurrentRelativeUrl()): string {
  const params = new URLSearchParams({
    forum_session_recovery: 'true',
    next,
  });
  return `/login?${params.toString()}`;
}

export function getSafeForumRecoveryNext(search: string): string | undefined {
  const next = new URLSearchParams(search).get('next');
  if (!next?.startsWith('/')) {
    return undefined;
  }

  try {
    const destination = new URL(next, window.location.origin);
    if (destination.origin !== window.location.origin) {
      return undefined;
    }

    return `${destination.pathname}${destination.search}${destination.hash}`;
  } catch {
    return undefined;
  }
}

export async function recoverForumSession(): Promise<void> {
  const response = await fetch('/api/discourse/session/recover', {
    method: 'POST',
    credentials: 'include',
    headers: {
      Accept: 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error(`Session recovery failed: ${response.status}`);
  }

  window.location.assign(getForumSessionRecoveryLoginUrl());
}
